
import Modal from "react-modal";
import styled from "styled-components";
import { CrossModal } from "./Icon/CrossModal";
import ArrowRight from "./Icon/ArrowRight";
import { cosmeticIQApi } from "../service/api";
import { useState } from "react";
import Loader from "./Loader";

import { useData } from "../context/DataProvider";


const SaveViewModal = ({ isOpen, onClose, data = [] ,productCount = 0}) => {
    const [title,setTitle] = useState('')
    const {data:data2,setData} = useData();
    const [loading,setLoading] = useState(false);
    function formatDate(date = new Date()) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

  const handleSaveView = async () => {
  try {
    setLoading(true);

    await cosmeticIQApi.saveView({
      title:title ? title : `Products view #${data2?.savedViews.length+1}`,
      filters: data,
      product_count: productCount,
    });
    const resp = await cosmeticIQApi.fetchSavedViews();
        setData(prev => ({ ...prev, savedViews: resp }));

  
    setTitle("");
    onClose();

  } catch (error) {
    console.error("Error saving report:", error);
  } finally {
    setLoading(false);
  }
};
  return (
    <Modal
               isOpen={isOpen}
               onRequestClose={()=>{onClose();}} 
               style={{
                   overlay: {  
                       backdropFilter: "blur(5px)", 
                       zIndex:1000,
                       backgroundColor: "rgba(255, 255, 255, 0.4)" 
                   }
                       ,
                   content: {
                       
                       top:'10%',
                       width: "50%",
                    
                       height: "70%",
                       margin: "auto",
                       display: "flex",
                       flexDirection: "column",
                       gap:'90px',
                       background:'none',
                       border: "none",
                       
                       
                   }
               }}
           >
      
     <div style={{display:'flex',justifyContent:'flex-end'}}>
                 <button 
                     onClick={()=>{onClose();}} 
                     style={{
                         position: "absolute", 

                         width:56,
                         background: '#FFFFFF',
                         border: '1.32px solid #FFFFFF4D',
                         boxShadow: '0px 0px 40px 0.66px #0000000F',

                         borderRadius:'64px',
                         height:56,
                         cursor: "pointer",
                         
     
                     }}
                 >
                     <CrossModal/>
                 </button>
                 </div>
           <A>
            <A1>
                <div style={{gap:16,display:'flex',flexDirection:'column'}}>
                <A1Txt>Save report</A1Txt>
                <A1Txt2 onChange={(e)=>setTitle(e.target.value)} value={title} placeholderColor='red' placeholder={`Products view #${data2?.savedViews.length+1}`}></A1Txt2>
                </div>
                <A1Txt>Date <span style={{ color: '#2F3237' }}>{formatDate()}</span></A1Txt>
                <ConditionsBlock>
                    <A1Txt>Filters</A1Txt>
                    <Buttons>
  {data?.map((filter,index) =>
    
      <Condition key={index}>
        <M11Txt color="#20232799">
           
  {filter.filter}
        </M11Txt>

        <M11Txt>{filter.option}</M11Txt>
      </Condition>
    
  )}
</Buttons>
                </ConditionsBlock>
                <Button onClick={handleSaveView} color="linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
">{loading ? <Loader/> :
    <>
    <A1Txt3>SAVE REPORT
</A1Txt3><ArrowRight/></>}</Button>
               


            </A1>
           </A>
    </Modal>
  );
};

export default SaveViewModal;
const Button = styled.button`
cursor:pointer;
align-items: center;
display:flex;
justify-content: center;
border:none;

height: 48px;
angle: 0 deg;
opacity: 1;
border-radius: 64px;
gap: 8px;
padding-top: 6px;
padding-right: 14px;
padding-bottom: 6px;
padding-left: 14px;
background:${props=>props.color};
`
const Buttons = styled.div`
display:flex;
flex-wrap:wrap;
gap:8px;`
const ConditionsBlock = styled.div`
display:flex;
flex-direction:column;
gap:8px;

`

const Condition = styled.div`
display:flex;
height: 43px;
angle: 0 deg;
opacity: 1;
border-radius: 12px;
padding: 12px;
gap: 6px;
background: #F9F9F9;
`
const A = styled.div`

angle: 0 deg;
opacity: 1;
border-radius: 32px;
padding: 32px;
border: 1.32px solid #FFFFFF4D;
box-shadow: 0px 0px 40px 0.66px #0000000F;
background: #FFFFFF;
border-width: 1.32px;
`
const A1 = styled.div`
gap:32px;
display:flex;
flex-direction:column;
`
const M11Txt = styled.p`
  font-family: PP Mori;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  leading-trim: NONE;
  margin:0;
  line-height: 120%;
  color: ${props => props.color || '#202327'};
  letter-spacing: 0%;
`
const A1Txt = styled.p`
font-family: PP Mori;
font-weight: 500;
font-style: Medium;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: 0%;
margin:0;
color: #2F323799;

`
const A1Txt3 = styled.p`
font-family: PP Mori;
font-weight: 800;
font-style: ExtraBold;
font-size: 12px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
vertical-align: bottom;
text-transform: uppercase;
margin:0;
color: #202327;
`
const A1Txt2 = styled.input`
font-family: PP Mori;
font-weight: 600;
border:none;
outline:none;

font-style: SemiBold;
font-size: 32px;
leading-trim: NONE;
line-height: 110.00000000000001%;
letter-spacing: -1%;
margin:0;
color: #202327;
 &::placeholder {
    color: #20232799;
  }`